export * from "./generated";

export const ICON_SIZES = ["sm", "md", "lg", "xl"] as const;
export type IconSizes = (typeof ICON_SIZES)[number];

export type ImageComponent =
  | "hero background"
  | "content image"
  | "video thumbnail"
  | "section background";

export type ContentfulImageFormat = "jpg" | "png" | "webp" | "gif" | "avif";
export interface ContentfulImageParams {
  h: number;
  w: number;
  q?: number;
  r?: string;
  fit?: "pad" | "fill" | "scale" | "crop" | "thumb";
  fm: ContentfulImageFormat[];
  f?:
    | "center"
    | "top"
    | "right"
    | "bottom"
    | "left"
    | "top_left"
    | "top_right"
    | "bottom_left"
    | "bottom_right"
    | "face"
    | "faces";
  aspectRatio?: string;
  gradientType?: "none" | "gradient" | "solid";
  gradientOverlay?: string;
  gradientDirection?: "to top" | "to bottom" | "to left" | "to right";
  gradientSize?: number;
  baseColor?: string;
  blendMode?: string;
  flipImage?: boolean;
  stretchImage?: boolean;
  focalPoint?: string;
  modifiedImageAspectRatio?: string;
}

export interface ContentfulImageConfig {
  default: ContentfulImageParams;
  mobile?: ContentfulImageParams;
  priority?: boolean;
}
